<template>
    <v-app-bar elevate-on-scroll app >
        <i class="burger" @click.stop="$emit('toggledrawer')">
            <span></span>
            <span></span>
            <span></span>
        </i>
        <v-toolbar-title><router-link to="/" ><logo></logo></router-link></v-toolbar-title>
        <!-- <v-icon large color="black">mdi-bell-outline</v-icon> -->
    </v-app-bar>
</template>

<script>
import logo from './Logo'


export default {
  name: 'mobile-navbar',
  components: { logo },
  data: () => {
      return {}
  },
  methods: {
  }
}
</script>

<style lang="scss">
.v-app-bar{
    width: 100vw;
    .v-toolbar__content{
        padding: 2em 1em!important;
        background: white;
        .burger{
            $burgerW: 1.8rem;
            height: $burgerW;
            width: $burgerW;
            position: relative;
            overflow: visible;
            span{
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 0.25rem;
                background: black;
                &:nth-child(2){
                    top: 50%;
                    transform: translate(15%,-50%);
                }
                &:last-child{
                    top: auto;
                    bottom: 0;
                }
            }
        }
        .v-toolbar__title{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
